import React, { Component } from 'react';
import {NavLink, Link} from 'react-router-dom';
import * as util from './util.js';
import configObject from './variables.js';

import './header.css';
import './footer.css';

export class Header extends Component {
  constructor(props) {
    super(props);
    this.openNav = this.openNav.bind(this);
    this.closeNav = this.closeNav.bind(this);
    this.toggleZoom = this.toggleZoom.bind(this);
    this.state = {
      zoomedIn: false
    }
  }

  componentDidMount() {
    window.scrollTo(0,0);
  }

  closeNav() {
    document.getElementById("mySidenav").style.width = "0";
    document.getElementById("content").style.opacity="1";
    if (document.getElementById("IdFeeBoxNG") !== undefined &&
        document.getElementById("IdFeeBoxNG") !== null )
    {
      document.getElementById("IdFeeBoxNG").style.opacity="1";
    }
    return true;
  }

  openNav() {
    document.getElementById("mySidenav").style.width = "100%";
    document.getElementById("content").style.opacity="0.1";
    if (document.getElementById("IdFeeBoxNG") !== undefined &&
        document.getElementById("IdFeeBoxNG") !== null ) {
          document.getElementById("IdFeeBoxNG").style.opacity="0.1";
    }

    document.getElementById("nav-icon2").classList.toggle('open');
    if(!document.getElementById("nav-icon2").classList.contains('open')) {
      this.closeNav();
    }
    return true;
  }

  toggleZoom (zoomFactor) {
    document.getElementById("app").style.transformOrigin="0 0";
    document.getElementById("app").style.transform="scale(" + (zoomFactor/100.0) + ")";
    if (zoomFactor > 100) {
      this.setState({ zoomedIn: true});
    } else {
      this.setState({ zoomedIn: false});
    }
  }


  render () {
    return (
      <div id="headerContainer">
      <Link to="/"><div className="logoImg"></div></Link>
      <div className="headerBeta" id="header">
        <div className="headerFirstDiv">
        <div className="headerText0"><Link className="headerAyaText" to="/">Ayacandas</Link></div>
          <div className="headerText2">
            <div className="headerAyaText">  Der Austausch-Marktplatz für Kliniken</div>
          </div>
        </div>
        <div className="headerSecondDiv" id="headerSecondDiv">
          <div className="links1">
            <div className="headerLink">
              <NavLink activeClassName="navSelected" className="headerLink" to="/" exact>Startseite</NavLink>
            </div>
            <div className="headerLink">
              <NavLink activeClassName="navSelected" className="headerLink" to="/search">Suchen</NavLink>
            </div>
            <div className="headerLink">
              <NavLink activeClassName="navSelected" className="headerLink" to="/update">Aktuelles</NavLink>
            </div>
            {
              this.props.username !== 'guest' &&
                <div className="headerLink">
                  <NavLink activeClassName="navSelected" className="headerLink" to="/product-list">Meine Angebote</NavLink>
                </div>
            }
            {
              this.props.username !== 'guest' &&
                <div className="headerLink">
                  <NavLink  activeClassName="navSelected" className="headerLink" to="/profile" >Meine Daten</NavLink>
                </div>
            }
            {
              util.isAdminUser() &&
                <div className="headerLink">
                  <NavLink activeClassName="navSelected" className="headerLink" to="/manage" >Verwalten</NavLink>
                </div>
            }
            <div className="headerLink">
              {
                this.props.username === 'guest' &&
                  <NavLink activeClassName="navSelected" className="headerLink" to="/login" title={this.props.username} >Login</NavLink>
              }
              {
                this.props.username !== 'guest' &&
                  <Link onClick={ () => this.props.propagateLogin(true, 'guest', 'guest', configObject.guestJWT)} className="headerLink" to="/" title={this.props.username} >Logout</Link>
              }
            </div>
          </div>
          <div className=" Zoom" id="zoomtoggle">
            <span style={this.state.zoomedIn === false ? {color:'white'} : null } className="ZoomOut" onClick={()=> this.state.zoomedIn === true && this.toggleZoom(100)}>A</span>
            <span  style={this.state.zoomedIn === true ? {color:'white'} : null } className="ZoomIn" onClick={()=>this.toggleZoom(110)}  >A</span>
          </div>
        </div>
        {/* Header for mobile */}
        <div className="headeTextMobil">
          <Link className="headeTextMobil" to="/">
            Ayacandas <br />
            Der Austausch-Marktplatz für Kliniken
          </Link>
        </div>
        <div id="mobileNav">
          <div className="NavIcon">
            <div id="nav-icon2" onClick={this.openNav} >
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <div className="sidenav" id="mySidenav" >
            <NavLink activeStyle={{color: '#eee197', pointerEvents:'none'}} onClick={()=>this.closeNav()} to="/search">Suchen</NavLink>
            {/*Only visible to loged in users*/}
            {(util.isNonCommercialUser() || util.isCommercialUser())&&
             <NavLink activeStyle={{color: '#eee197', pointerEvents:'none'}} onClick={()=>this.closeNav()} to="/product-list">Anbieten</NavLink>
            }
            <NavLink activeStyle={{color: '#eee197', pointerEvents:'none'}} onClick={()=>this.closeNav()} to="/update">Aktuelles</NavLink>
            {this.props.username !== 'guest' &&
             <NavLink activeStyle={{color: '#eee197', pointerEvents:'none'}} onClick={()=>this.closeNav()} to="/profile">Meine Daten</NavLink>
            }
            {util.isAdminUser() &&
             <NavLink activeStyle={{color: '#eee197', pointerEvents:'none'}} onClick={()=>this.closeNav()} to="/manage">Verwalten</NavLink>
            }
            {this.props.username !== 'guest' &&
             <NavLink to="/" onClick={ () => this.props.propagateLogin(true, 'guest', 'guest', configObject.guestJWT)} >Logout</NavLink>
            }
            {this.props.username === 'guest' &&
             <NavLink to="/login">Login</NavLink>
            }
          </div>
        </div>
      </div>
      </div>
  );
}
}



// WEBPACK FOOTER //
// ./src/header.js